import React, { Component } from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { toggleAddProgrammePopup, toggleExtensionPopup, toggleNotification, toggleResubmissionPopup } from '../../redux/reducers/view';
import { getUserProgramsFullRequest, selectAssessment, selectAssessmentContent, selectRollout, selectUserContent, selectUserModule, selectUserPrograms, setApproved, setCost } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import * as moment from 'moment';

import AvatarCirce from '../AvatarCircle';
import md5 from "md5";

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBSelect } from 'mdbreact';
import { connectedUsersRequest } from '../../redux/reducers/connectedUsers';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import ExtensionComponent from '../ExtensionComponent';

import FileActions from '../FileActions';
import { selectedContent } from '../../redux/selectors';
import { assignmentRequestRequest, setComment, setFile, setFileCount, setFileIndex, setMediaType, setRequestType } from '../../redux/reducers/assignmentRequest';


class ExtensionPopup extends Component {
  state = {
    modal: true,
    page: 'decision',
    selectedFiles: [],
    progressInfos: [],
    message: [],
    fileInfos: [],
    comment:'',
    mediaType:'document',
    index:0,
    options: [{"text":'Proof of payment', "value":'pop'}, {"text":'Corroborating documents', "value":'document'}]
  };

  constructor() {
    super();
    this.hiddenFileInput = React.createRef();
  }

  componentWillReceiveProps(nextProps){
   
    
    
    if((nextProps.assignmentRequestReducer.fetching==true) && this.props.assignmentRequestReducer.fetching==false &&  nextProps.view.extensionPopup){
      this.setState({page:'loading'})
    }else if(nextProps.assignmentRequestReducer.isFetched==true && this.props.assignmentRequestReducer.isFetched==false &&  nextProps.view.extensionPopup){
      
      if(this.props.assignmentRequestReducer.fileIndex<this.props.assignmentRequestReducer.file_count){
        
  
        this.sendRequest(null)
        this.setState({page:'loading'})
      }else{
        
        this.props.setFileIndex(0)
        this.props.setFileCount(0)
        this.setState({page:'completed'})
      }
      
    }else if((this.props.view.extensionPopup && !nextProps.view.extensionPopup && this.state.page!='completed')){
      
      if(nextProps.userProgramsFull.assessmentContent && nextProps.userProgramsFull.extensions_left>0 &&  nextProps.view.extensionPopup){
      
        this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'freeAttempt',options:[{"text":'Corroborating documents', "value":'document'}]})
      }else{
        this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision',options:[{"text":'Proof of payment', "value":'pop'},{"text":'Corroborating documents', "value":'document'}]})
      }
      
    }else{
      if(nextProps.userProgramsFull.assessmentContent && nextProps.userProgramsFull.extensions_left>0 && this.state.page!='completed' &&  nextProps.view.extensionPopup){
        
     
        this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'freeAttempt', options:[{"text":'Corroborating documents', "value":'document'}]})
      }else if(nextProps.userProgramsFull.assessmentContent && nextProps.userProgramsFull.extensions_left<=0 && this.state.page!='completed' &&  nextProps.view.extensionPopup){
         if(this.props.userProgramsFull.extensions_left<1){
          
          this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision', options:[{"text":'Proof of payment', "value":'pop'}, {"text":'Corroborating documents', "value":'document'}]})
         }else{
          
       
          this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision', options:[{"text":'Corroborating documents', "value":'document'}]})
         }
      }
    }

    // if(this.props.view.extensionPopup && !nextProps.view.extensionPopup){
    //   if(nextProps.userProgramsFull.assessmentContent.extensions_left>0){
    //     
    //     this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'freeAttempt', index:0})
    //   }else{
    //     
    //     this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision', index:0})
    //   }
    // }
   
   

    
    
  }


  toggle = (e) => {
    if(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.extensions_left>0 && this.props.view.extensionPopup){
    
      this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'freeAttempt'})
    }else if(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.extensions_left<=0 && this.props.view.extensionPopup){
      
   
      this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision'})
    }
    this.setState({options:[{"text":'Proof of payment', "value":'pop'}, {"text":'Corroborating documents', "value":'document'}]})
   this.props.toggleExtensionPopup(false)
  }

  sendRequest = event => {
   
    
     
      
      this.props.setComment(this.state.comment);
      this.props.setFile(this.state.selectedFiles[this.props.assignmentRequestReducer.fileIndex])
      this.props.setFileCount(this.state.selectedFiles.length);
      this.props.setMediaType(this.state.mediaType)
      this.props.selectUserPrograms(parseInt(this.props.userProgramsFull.assessmentContent.program_id))
      this.props.selectUserModule(parseInt(this.props.userProgramsFull.assessmentContent.module_id))
      this.props.selectAssessment(parseInt(this.props.userProgramsFull.assessmentContent.survey_id))
      this.props.selectRollout(parseInt(this.props.userProgramsFull.assessmentContent.rollout_id))
      this.props.setRequestType('extension')
      this.props.setCost(this.props.userProgramsFull.assessmentContent.survey_cost)
      this.props.selectUserContent(parseInt(this.props.userProgramsFull.assessmentContent.contentId))
      this.props.setApproved(0)
      this.props.assignmentRequestRequest('extension')
      this.props.setFileIndex(this.props.assignmentRequestReducer.fileIndex+1)      
    
       this.setState({page:"loading"})
   
  };

  showRequest = (e) => {
    this.setState({page:"upload"})
   }
   showDecision = (e) => {
    if(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.extensions_left>0){
     
      this.setState({page:'freeAttempt'})
    }else{
      this.setState({page:'decision'})
    }
   }

   payment = (e) => {
    this.refs.payfast.submit();
   }
   removeFile = (e) => {
    
    var tmp = this.state.selectedFiles
    for (let index = 0; index < tmp.length; index++) {
      if(e.name==tmp[index].name){
        tmp.splice(index,1)
      }
    }
    this.setState({
      progressInfos: [],
      selectedFiles: tmp,
    });
   }

   handleClick = event => {
    
    this.hiddenFileInput.current.click();
  };

  handleChange = event => {
    const fileUploaded = event.target.files;
    var files= [];
    for (let index = 0; index < fileUploaded.length; index++) {
      const element = fileUploaded[index];
      
      files.push(element)
    }
   
    this.setState({
      progressInfos: [],
      selectedFiles: files,
    });
    //setImage(event.target.files[0])
  };

  handleChangeComment = event => {
    
    this.setState({comment:event})
  }
  onChangeDoc = event => {
   
    if(this.state.mediaType!=event[0] && event.length!=0){
     if(event[0]=='pop'){
      this.setState({mediaType:event[0], options:[{"text":'Proof of payment', "value":'pop', "checked":true}, {"text":'Coroborating documents', "value":'document'}]})
     }else{
      this.setState({mediaType:event[0], options:[{"text":'Proof of payment', "value":'pop'}, {"text":'Coroborating documents', "value":'document', "checked":true}]})
     }
     
    }
     
    }
 
  render() {
    const timerStr = this.props.loginReducer.user && this.props.loginReducer.user.userId+'-'+moment().format("X");
    const params = new URLSearchParams({
      merchant_id: "17694422",
      merchant_key: "3qdvwf3bonmqn",
      return_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=true&reference='+timerStr+'&rollout_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.rollout_id)+'&program_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.program_id)+'&module_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.module_id)+'&survey_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_id)+'&type=extension&cost='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'&content_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.contentId),
      cancel_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=false',
      notify_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=middle',
      name_first: this.props.loginReducer.user && this.props.loginReducer.user.firstName,
      name_last: this.props.loginReducer.user && this.props.loginReducer.user.lastName,
      email_address: this.props.loginReducer.user && this.props.loginReducer.user.email,
      amount: (this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost),
      item_name: timerStr,
      passphrase:escape("Cpslearn_payments_2021")
     
    });
   
    // passphrase: escape( "Cpslearn_payments_2021" ),
    const MD5Signature = md5(params.toString())
        console.log('HAsh22', MD5Signature)
        return (
          <div>
            <form action="https://www.payfast.co.za/eng/process" method="POST" ref="payfast">
               <input type="hidden" name="merchant_id" value="17694422" />
               <input type="hidden" name="merchant_key" value="3qdvwf3bonmqn" />
               <input type="hidden" name="return_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=true&reference='+timerStr+'&rollout_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.rollout_id)+'&program_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.program_id)+'&module_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.module_id)+'&survey_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_id)+'&type=extension&cost='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'&content_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.contentId)} />
               <input type="hidden" name="cancel_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=false'} />
               <input type="hidden" name="notify_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=middle'} />
               <input type="hidden" name="name_first" value={this.props.loginReducer.user && this.props.loginReducer.user.firstName} />
               <input type="hidden" name="name_last" value={this.props.loginReducer.user && this.props.loginReducer.user.lastName} />
               <input type="hidden" name="email_address" value={this.props.loginReducer.user && this.props.loginReducer.user.email} />
               <input type="hidden" name="amount" value={(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)} />
               <input type="hidden" name="item_name" value={timerStr} />
               <input type="hidden" name="signature" value={MD5Signature} />
               
        </form>
    <input type="file"
             ref={this.hiddenFileInput}
             style={{display:'none', position:'absolute', top:0, left:0}} 
             onChange={this.handleChange}
            multiple
      /> 
        {this.props.view.extensionPopup && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:1000000}}>
        
        <ExtensionComponent
          page={this.state.page}
          commentTxt = {{
            onChange: (e) => {
              this.handleChangeComment(e.target.value)
            },
            value: this.state.comment
          }}
          pricing = {
            this.props.userProgramsFull.extensions_left<=0 ? 'The cost of an Extension Request for this rollout is R'+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'.00. If you would like to pay electronically, click Pay Now.  Alternatively, you can submit your request for consideration or upload your proof of payment by clicking on Request.' : 'We acknowledge receipt of your request. In order to process, please provide the reason for the extension request together with supporting documentation. Please contact your Support Consultant should you require clarity around the Extension Policy.  Click on "Request" below to continue.    '
          }
          successTxt = {
            this.props.userProgramsFull.extensions_left<0 ? 'Thank you for your request. We will notify you once it is processed.' : this.props.contentReducer.fetchingItem==true ? 'Please wait... ' : 'Thank you for your request.  You have '+(this.props.userProgramsFull.extensions_left)+' free extensions left.'
          }
          fileHolder = {{
            children : this.state.selectedFiles.map(item => (
              <div>
                
              
              <FileActions
                page={this.state.page}
                removeBtn = {{
                  onClick: (e) =>{
                    this.removeFile(item)
                  }
                }}
                fileName = {item.name}
              
              /></div>
                ))
          }}

          loadingHolder = {{
            children: <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>
              <div>
           
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
           color={COLORS.cornerstoneRed}
           loading={true}
         />
        </div>
         </ReactCSSTransitionGroup>
          }}
          closeBtn = {{
            onClick: (e) =>{
              this.toggle(e)
            }
          }}
          bigCloseBtn = {{
            onClick: (e) =>{
              this.toggle(e)
            }
          }}
          requestBtn = {{
            onClick: (e) =>{
              this.showRequest(e)
            }
          }}
          freeRequestBtn = {{
            onClick: (e) =>{
              this.showRequest(e)
            }
          }}



          backBtn = {{
            onClick: (e) =>{
              
              this.showDecision(e)
            }
          }}
          payNowBtn= {{
            onClick: (e) =>{
              this.payment(e)
            }
          }}
          chooseBtn = {{
            onClick: (e) =>{
              this.handleClick(e)
            }
          }}
          sendBtn= {{
            onClick: (e) =>{
              this.sendRequest(e)
            }
          }}
          docType = {{
            children: <MDBSelect
              name='docType'
              label='Type of document'
              
              options={this.state.options}
             
              getValue={this.onChangeDoc}
              style={{zIndex:10000}}
            />
          }}
        />
      </div>}
      </div>
    
);
    }
  }

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});

const mapStateToProps = state => ({
  view: state.viewReducer,
  assignmentRequestReducer: state.assignmentRequest,
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  contentReducer: state.contentListReducer,

});
const mapDispatchToProps = dispatch => ({
  toggleExtensionPopup: value => dispatch(toggleExtensionPopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleNotification: value => dispatch(toggleNotification(value)),
  assignmentRequest:string => dispatch(assignmentRequestRequest(string)),
  setComment:string => dispatch(setComment(string)),
  setFile:file => dispatch(setFile(file)),
  setFileCount:int => dispatch(setFileCount(int)),
  setMediaType:int => dispatch(setMediaType(int)),
  selectUserContent:int => dispatch(selectUserContent(int)),
  selectUserModule:int => dispatch(selectUserModule(int)),
  selectUserPrograms:int => dispatch(selectUserPrograms(int)),
  selectAssessmentContent:int => dispatch(selectAssessmentContent(int)),
  selectAssessment:int => dispatch(selectAssessment(int)),
  selectRollout:int => dispatch(selectRollout(int)),
  setFileIndex:int => dispatch(setFileIndex(int)),
  setRequestType:string => dispatch(setRequestType(string)),
  setCost:string => dispatch(setCost(string)),
  setApproved:string => dispatch(setApproved(string)),
  assignmentRequestRequest:string => dispatch(assignmentRequestRequest(string)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter,
  withState('loading', 'toggleLoading', false),
  withHandlers({
    handleCloseNow: props => event => {
      
      props.toggleResubmissionPopup(false)
    }
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.getUserProgramsFullRequest();
    },
    
  }),
  withStyles(styles),
)(ExtensionPopup);

ExtensionPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};
